import React, {FC} from "react"
import {StyledEmptyField} from "./styles"

const EmptyFieldError: FC = () => (
    <StyledEmptyField>
        Cannot be empty
    </StyledEmptyField>
)

export default EmptyFieldError
